/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'
import CongressContext from './CongressContext'

export interface ComponentProps {
  congress?: any;
  setCongress?: (congress?: any, config?: any) => void;
}

const withCongress = <P extends object>(Component: React.ComponentType<P & ComponentProps>) =>
  class withCongress extends React.Component<P> {
    static contextType = CongressContext

    render () {
      const { congress, setCongress, config } = this.context

      // This will display the correct congress name.
      document.title = congress.Name ? `Inscripciones ${congress.Name}` : 'Trazo Events: Inscripciones'

      return (
        <Component
          {...this.props as P}
          congress={congress || {}}
          setCongress={setCongress}
          config={config || {}}
        />
      )
    }
  }

export default withCongress
